export default function initAnalytics() {
  const script = document.createElement(`script`)
  script.src = `https://plausible.io/js/pa-3mzw2spLj9WKIAmFgxSjP.js`
  script.defer = true
  document.head.appendChild(script)

  window.plausible =
    window.plausible ||
    function (...args) {
      ;(window.plausible.q = window.plausible.q || []).push(args)
    }

  window.plausible.init =
    window.plausible.init ||
    function (i) {
      window.plausible.o = i || {}
    }

  window.plausible.init({
    autoCapturePageviews: false,
    captureOnLocalhost: false,
  })

  window.addEventListener(`phx:page-loading-stop`, (e) => {
    if (e.detail.kind != `initial`) return

    const {
      analyticsGuideSlug: guideSlug,
      analyticsCountySlug: countySlug,
      analyticsOrganizationSlug: organizationSlug,
    } = window.main?.dataset || {}

    const props = {}

    if (guideSlug) props.guide = guideSlug
    if (countySlug) props.county = countySlug
    if (organizationSlug) props.organization = organizationSlug

    window.plausible(`pageview`, { props })
  })
}
